import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PostPayloadInterface} from '../../models/post-payload.interface';
import {SuperRepoRepository} from './super-repo.repository';

@Injectable({
  providedIn: 'root'
})
export class NoteRepository extends SuperRepoRepository{
  constructor(httpClient: HttpClient) {
    super();
    this.httpClient=httpClient;
  }

  saveNote(payload:PostPayloadInterface, entity:string){
    const path = 'dashboard/staff/'+entity.toLowerCase()+'/add-note';
    return super.post(path, payload);
  }
}
